// extracted by css-extract-rspack-plugin
export default {"root":"hR52I","label":"KHNrH","innerInput":"EVRdE","wrapper":"cFxdT","input":"yVVPa","error":"pCGnu","visibilityToggle":"rfrwg","section":"CDh80"};